/**
 * Набор хелперов для работы с загрузкой файлов
 */

/**
 * Метод для простой загрузки файлов
 * @param url путь к файлу
 */
export const downloadFile = (url) => {
    const a = document.createElement('a');
    a.href = url;
    a.download = '';

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};
